import { restClient } from '@/Core'

import { DISK_ADMIN_API } from './diskAdminApi'

import type { DiskAdminFilter, DiskAdminOrder, DiskAdminSort, DiskAdminStorageList } from '../Contracts/DiskAdmin'

export interface DiskAdminStoragesQuery {
    filter: DiskAdminFilter
    q: string
    sort: DiskAdminSort
    order: DiskAdminOrder
    limit: number
    offset: number
}

/**
 * Список дисків: `GET /services/disk/admin/storages` — рядок на співробітника
 * (зокрема без диска) і на кожен спільний простір; `counts` чипів рахує той
 * самий екшен, тож лічильник = рядків таблиці.
 */
export const LoadDiskAdminStoragesTask = async (query: DiskAdminStoragesQuery): Promise<DiskAdminStorageList> => {
    const q = query.q.trim()

    return (await restClient.get(
        `${DISK_ADMIN_API}/storages`,
        {
            searchParams: {
                filter: query.filter,
                sort: query.sort,
                order: query.order,
                limit: query.limit,
                offset: query.offset,
                ...(q !== '' ? { q } : {}),
            },
        },
        { forceRefresh: true }
    )) as unknown as DiskAdminStorageList
}
